
// src/web/components/group-members-panel.jsx

import React from 'react'
import connect from '../../connects/group-members-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  IconMenu,
  MenuItem,
  MenuDivider,
} from 'react-toolbox/lib/menu'
import Dropdown from 'react-toolbox/lib/dropdown'
import Switch from 'react-toolbox/lib/switch'
import ConfirmDialog from './confirm-dialog.jsx'
import GuideMessage from './guide-message.jsx'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import lightButtonTheme from './themes/light-button.css'
import sortableTheme from './themes/sortable.css'
import groupMembersSortingTheme from './themes/group-members-sorting.css'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'
import { track } from '../../helpers/analytics'
import _ from 'lodash'

function AdminMenu(props) {

  const {
    disabled,
    member,
    updateGroupMembership,
  } = props
  return (
    <div style={{ width: 150, height: 52, right: 0, paddingTop: 15}}>
      <Switch
        checked={member.is_admin}
        disabled={disabled}
        onChange={(value) => updateGroupMembership(props, member, value ? 'admin':'member')}/>
    </div>
  )
}

const SortableListItem = SortableElement(ListItem)

class GroupMemberList extends React.Component {
  state = {}

  render() {
    const {
      t,
      ui,
      updateUI,
      group,
      user,
      sorting,
      selectSorting,
      isMembershipUpdating,
      addGroupMembership,
      updateGroupMembership,
      showUserSelectionDialog,
      usersAdminUrl,
      usersAccountUrl,
    } = this.props

    if (!group.members || group.members.length == 0)
      return null

    return (
      <div style={{ cursor: sorting && 'move' || 'inherit' }}>
        <div key="title" className={theme.labelContainer}>
          <div key="membership" className={theme.adminLabel}>{t('label:管理者')}</div>
        </div>
        <List>
        {_.map(group.members, (member, i)=>
          <SortableListItem key={member.user_id} selectable={false} ripple={false} index={i}
              theme={groupMembersSortingTheme}
              className={(selectSorting ? 'active_sorting' : '')}
              disabled={!sorting}
              avatar={member.icon_image.thumb_url}
              caption={member.name}
              rightActions={_.filter([
                <AdminMenu key="admin_menu" t={t} disabled={user.user_id == member.user_id} group={group} member={member} isMembershipUpdating={isMembershipUpdating} updateGroupMembership={updateGroupMembership} />,
                <IconButton key="remove" icon="close" disabled={user.user_id == member.user_id} onClick={()=> this.setState({ [`deleteConfirm${member.user_id}`]: true })} />,
                <ConfirmDialog key="remove_dialog"
                    title={t('label:ユーザを削除してもいいですか', { name: member.name })}
                    description={t('label:ユーザを削除しても過去の投稿は閲覧することができます')}
                    open={this.state[`deleteConfirm${member.user_id}`]}
                    yesLabel={t('label:外す')}
                    noLabel={t('label:取り消し')}
                    onYes={()=> { this.setState({ [`deleteConfirm${member.user_id}`]: false })
                                  updateGroupMembership(this.props, member, 'delete')
                                  updateUI({ active: true }) }}
                    onNo={()=> this.setState({ [`deleteConfirm${member.user_id}`]: false })} />
              ], (item)=> item)} />
        )}
        </List>

        { user && user.account_admin &&
          <ConfirmDialog key="delete_user_dialog"
              title={t('label:アカウント管理画面から操作')}
              open={ui.active}
              onYes={()=> updateUI({ active: false })}
              onNo={()=> updateUI({ active: false })}
              yesHref={usersAccountUrl}
              yesLabel={t('label:アカウント管理画面へ')}
              noLabel={t('label:閉じる')} />
        }
      </div>
    )
  }
}

const SortableGroupMemberList = SortableContainer(GroupMemberList)

class GroupMembersPanel extends React.Component {
  state = { selectSorting: false }　
  openURL = () => track('invite_users')
  showUserSelectionDialog = () => {
    this.props.showUserSelectionDialog(
      this.props.t('label:ユーザを選択'), true,
      'OTHER_MEMBERS', this.props.group && this.props.group, undefined,
      (users)=> this.props.addGroupMembership(this.props, users)
    )
    track('group_members_add')
  }
  onSortEnd = (index)=> {
    this.setState({ sorting: false })
    this.props.sortGroupMembers(this.props, arrayMove(this.props.group.members.map((item)=> item.user_id), index.oldIndex, index.newIndex))
  }
  startSorting = ()=> {
    this.setState({ sorting: !this.state.sorting })
    !this.state.sorting && this.props.startSorting()
  }
  onSortStart  = ()=> {
    this.setState({ selectSorting: !this.state.selectSorting })
  }

  render() {
    const {
      t,
      group,
      user,
      isMembershipUpdating,
      addGroupMembership,
      updateGroupMembership,
      showUserSelectionDialog,
      startSorting,
      usersAdminUrl,
      hasMembers,
      firstLogin,
      otherMembers,
    } = this.props

    return (
      <Card theme={theme}>
        <CardActions>
          {user && user.account_admin &&
            <Button raised primary
              icon='add'
              label={t('label:新規ユーザを招待')}
              onClick={this.openURL}
              href={usersAdminUrl}
              target='_blank'
              rel="noopener noreferrer" />
          }
          {otherMembers &&
            <Button raised theme={successButtonTheme}
              icon='add'
              label={t('label:既存ユーザを追加')}
              onClick={this.showUserSelectionDialog} />
          }
          <Button raised={this.state.sorting}
            theme={lightButtonTheme}
            icon='sort'
            label={t('label:並べ替え')}
            onClick={this.startSorting} />
        </CardActions>
        {user && user.account_admin && firstLogin && !hasMembers &&
          <CardActions>
            <GuideMessage showMessage={true}
              message={t('label:ここをクリックして招待してみよう')} />
          </CardActions>
        }

        <CardText>
          {(!group.members || group.members.length == 0) &&
            <List >
              <ListItem caption={t('label:メンバーは登録されていません')} />
            </List>
          }
          <SortableGroupMemberList {...this.props}
            onSortEnd={this.onSortEnd}
            onSortStart={this.onSortStart}
            helperClass={sortableTheme.sortable}
            sorting={this.state.sorting}
            selectSorting={this.state.selectSorting} />
        </CardText>
      </Card>
    )
  }
}

export const RawGroupMembersPanel = GroupMembersPanel
export default connect(GroupMembersPanel)



// WEBPACK FOOTER //
// ./src/web/components/group-members-panel.jsx